import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import AddTicketForm from 'src/components/Forms/AddTicketForm';

const AddTicketModal = () => (
  <ModalBase
    name={MODALS.addTicket}
    size={MODALS_SIZE.medium}>
    <AddTicketForm />
  </ModalBase>
);

export default AddTicketModal;
